import { Component, EventEmitter, Input, Output } from '@angular/core';


export class SkyChevronComponent {
  
  public directionChange = new EventEmitter<string>();

  
  public direction = 'up';

  
  public disabled: boolean = false;

  public chevronClick() {
    this.direction = this.direction === 'up' ? 'down' : 'up';
    this.directionChange.emit(this.direction);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-chevron',
  styles: [`.sky-chevron {
  border: none;
  background-color: transparent;
  flex-shrink: 0;
  height: 24px;
  margin: 0;
  overflow: hidden;
  padding: 0;
  width: 24px;
  cursor: pointer;
}

.sky-chevron:hover .sky-chevron-part {
  border-color: #979ba2;
}

.sky-chevron-part {
  border-color: #cdcfd2;
  border-style: solid;
  border-width: 3px 0 0 0;
  display: inline-block;
  height: 10px;
  position: relative;
  top: 6px;
  transition: transform 250ms, left 250ms;
  vertical-align: top;
  width: 10px;
}

.sky-chevron-up .sky-chevron-left {
  left: 7px;
  transform: rotate(-45deg);
}

.sky-chevron-up .sky-chevron-right {
  left: -6px;
  transform: rotate(45deg);
}

.sky-chevron-down .sky-chevron-left {
  left: 2px;
  transform: rotate(45deg);
}

.sky-chevron-down .sky-chevron-right {
  left: -1px;
  transform: rotate(-45deg);
}
`],
  template: `<button
    type="button"
    class="sky-chevron"
    [ngClass]="['sky-chevron-' + direction]"
    (click)="$event.stopPropagation();chevronClick()"
    [attr.aria-label]="(direction === 'down' ? 'chevron_expand' : 'chevron_collapse') | skyResources"
    [disabled]="disabled"
>
  <i class="sky-chevron-part sky-chevron-left"></i>
  <i class="sky-chevron-part sky-chevron-right"></i>
</button>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'directionChange': [{ type: Output },],
'direction': [{ type: Input },],
'disabled': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
